module.exports = __webpack_public_path__ + "static/media/kitty6.dcdc30d9.jpg";